import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import { Mail, MapPin, Instagram, Twitter } from 'lucide-react';

const LOGO_URL = '/images/soursweet-logo.png';

export const Footer = () => {
  const { language } = useLanguage();
  const currentYear = new Date().getFullYear();

  return (
    <footer data-testid="footer" className="bg-lime-100 border-t border-lime-200 print:hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-12 pt-16 pb-8">
        {/* Main Footer Content - 3 Column Layout */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Column 1: Tagline */}
          <div className="flex flex-col">
            <h4 className="font-heading text-sm tracking-widest uppercase text-emerald-800 font-extrabold mb-6">
              SourSweet
            </h4>
            <p className="text-emerald-700 font-semibold">
              {language === 'de' 
                ? 'Premium Food Truck Catering' 
                : 'Premium Food Truck Catering'}
            </p>
            {/* Social Icons */}
            <div className="flex items-center gap-4 mt-4">
              <a
                href="https://www.instagram.com/soursweet.de/"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 rounded-full hover:bg-lime-200 hover:shadow-[0_0_20px_rgba(251,146,60,0.6)] transition-all duration-300"
                data-testid="footer-instagram"
              >
                <Instagram size={24} className="text-emerald-700" />
              </a>
              <a
                href="https://x.com/SourSweet_de"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 rounded-full hover:bg-lime-200 hover:shadow-[0_0_20px_rgba(251,146,60,0.6)] transition-all duration-300"
                data-testid="footer-twitter"
              >
                <Twitter size={24} className="text-emerald-700" />
              </a>
            </div>
          </div>

          {/* Column 2: Kontakt */}
          <div className="flex flex-col">
            <h4 className="font-heading text-sm tracking-widest uppercase text-emerald-800 font-extrabold mb-6">
              {language === 'de' ? 'KONTAKT' : 'CONTACT'}
            </h4>
            <div className="space-y-4">
              <a
                href="mailto:info@soursweet.de?subject=Anfrage%20von%20der%20Website"
                data-testid="footer-email"
                className="inline-flex items-center gap-3 text-emerald-700 font-semibold hover:bg-lime-200 hover:shadow-[0_0_20px_rgba(251,146,60,0.6)] px-3 py-1.5 rounded-full -ml-3 transition-all duration-300"
              >
                <Mail size={18} className="text-lime-600" />
                info@soursweet.de
              </a>
              <div className="flex items-start gap-3 text-emerald-700 font-semibold">
                <MapPin size={18} className="text-lime-600 mt-0.5 flex-shrink-0" />
                <span>
                  {language === 'de' 
                    ? 'Mobil - Wir kommen zu Ihnen!' 
                    : 'Mobile - We come to you!'}
                </span>
              </div>
            </div>
          </div>

          {/* Column 3: Öffnungszeiten */}
          <div className="flex flex-col">
            <h4 className="font-heading text-sm tracking-widest uppercase text-emerald-800 font-extrabold mb-6">
              {language === 'de' ? 'ÖFFNUNGSZEITEN' : 'HOURS'}
            </h4>
            <p className="text-emerald-700 font-semibold mb-2">
              {language === 'de' ? 'Mo-So: Nach Vereinbarung' : 'Mon-Sun: By Appointment'}
            </p>
            <p className="text-emerald-600 font-medium text-sm">
              {language === 'de' 
                ? 'Verfügbar für Events und besondere Anlässe. Buchen Sie im Voraus!' 
                : 'Available for events and special occasions. Book in advance!'}
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-10 pt-8 border-t border-lime-200 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-emerald-600 font-semibold text-sm">
            © 2014 SourSweet. {language === 'de' ? 'Alle Rechte vorbehalten.' : 'All rights reserved.'}
          </p>
          
          <div className="flex items-center gap-2 text-sm font-semibold">
            <Link to={language === 'de' ? '/datenschutz' : '/privacy'} className="text-emerald-700 hover:bg-lime-200 hover:shadow-[0_0_20px_rgba(251,146,60,0.6)] px-2 py-1 rounded-full transition-all duration-300">
              {language === 'de' ? 'Datenschutz' : 'Privacy Policy'}
            </Link>
            <span className="text-lime-300">|</span>
            <Link to={language === 'de' ? '/agb' : '/terms'} className="text-emerald-700 hover:bg-lime-200 hover:shadow-[0_0_20px_rgba(251,146,60,0.6)] px-2 py-1 rounded-full transition-all duration-300">
              {language === 'de' ? 'AGB' : 'Terms & Conditions'}
            </Link>
            <span className="text-lime-300">|</span>
            <Link to={language === 'de' ? '/impressum' : '/imprint'} className="text-emerald-700 hover:bg-lime-200 hover:shadow-[0_0_20px_rgba(251,146,60,0.6)] px-2 py-1 rounded-full transition-all duration-300">
              {language === 'de' ? 'Impressum' : 'Imprint'}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
